import React from "react";

export function H1({ children }) {
  return <h1 className="font-heading text-3xl sm:text-4xl font-black">{children}</h1>;
}

export function Sub({ children }) {
  return <p className="text-zinc-400 mt-2">{children}</p>;
}

export function Skeleton() {
  return <div className="pp-card p-10 text-center text-zinc-500">Loading...</div>;
}

export function IconBtn({ children, onClick, danger, title, ...rest }) {
  return (
    <button
      onClick={onClick}
      title={title}
      {...rest}
      className={`p-2 rounded-lg border transition-colors ${
        danger
          ? "border-[#FF3B30]/30 text-[#FF3B30] hover:bg-[#FF3B30]/10"
          : "border-white/10 text-zinc-300 hover:border-[#00E676]/40 hover:text-[#00E676]"
      }`}
    >
      {children}
    </button>
  );
}
